"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropDown = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Autocomplete = _interopRequireDefault(require("../Autocomplete/Autocomplete"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DropDown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown() {
    var _this;

    (0, _classCallCheck2.default)(this, DropDown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          disabled = _this$props.disabled,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          required = _this$props.required,
          label = _this$props.label,
          helperText = _this$props.helperText,
          placeholder = _this$props.placeholder,
          onChange = _this$props.onChange,
          options = _this$props.options,
          value = _this$props.value,
          className = _this$props.className,
          sortMenuOptions = _this$props.sortMenuOptions,
          isInDialog = _this$props.isInDialog,
          variant = _this$props.variant,
          inputProps = _this$props.inputProps,
          styles = _this$props.styles,
          fullWidth = _this$props.fullWidth,
          margin = _this$props.margin,
          isClearable = _this$props.isClearable;
      return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
        id: id,
        className: (0, _classnames.default)("prmbl-dropDown", className),
        helperText: helperText,
        label: label,
        onChange: onChange,
        value: value,
        options: options,
        sortMenuOptions: sortMenuOptions,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        error: error,
        margin: margin,
        errorMessage: errorMessage,
        isInDialog: isInDialog,
        variant: variant,
        inputProps: inputProps,
        styles: styles,
        fullWidth: fullWidth,
        isClearable: isClearable
      });
    });
    return _this;
  }

  return DropDown;
}(_react.Component);

exports.DropDown = DropDown;
(0, _defineProperty2.default)(DropDown, "propTypes", {
  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.bool,

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.string,

  /**
   * If `true`, renders the dropdown the full width of the containing component
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The contents of the `helper text`
   */
  helperText: _propTypes.default.node,

  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * The contents of the `label`
   */
  label: _propTypes.default.node,

  /**
   * Callback fired when the value is changed.  `function(object) => void`
   *
   * `object` : The value selected. You can pull out the new value via `object.value`
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * The options bound to the dropdown
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * The label to be displayed, if not provided 'value' will be used.
     */
    label: _propTypes.default.string,

    /**
     * Used as the value; One of type: string, number
     */
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  })),

  /**
   * If `true` the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * If `true` sorts the options
   */
  sortMenuOptions: _propTypes.default.bool,

  /**
   * The value for the element
   */
  value: function value(props, propName, componentName) {
    var value = props[propName];

    if (typeof value === "string") {
      return null;
    }

    if (typeof value === "number") {
      return null;
    }

    if ((0, _typeof2.default)(value) === "object") {
      return null;
    }

    if (value == null) {
      return null;
    }

    return new Error("".concat(propName, " in ").concat(componentName, " must be of type string, number, or null."));
  },

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * Text to display before a user selects a value
   */
  placeholder: _propTypes.default.string,

  /**
   * If `true`, the Autocomplete will portal to `document.body`.
   */
  isInDialog: _propTypes.default.bool,

  /**
   * How the input appears on page.
   */
  variant: _propTypes.default.oneOf(["standard", "outlined", "filled", "compact", "inline"]),

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Style override object for conditional styling. See https://react-select.com/styles
   */
  styles: _propTypes.default.object,

  /**
   * Whether the value can be cleared
   */
  isClearable: _propTypes.default.bool,

  /**
   * If false, the TextInput will not have a built-in margin
   */
  margin: _propTypes.default.bool
});
(0, _defineProperty2.default)(DropDown, "defaultProps", {
  sortMenuOptions: true,
  className: "",
  id: "",
  isInDialog: false,
  isClearable: false
});
var _default = DropDown;
exports.default = _default;